//#region src/components/Typography/Typography.module.css
var e = "_text_39g1u_1", t = "_small_39g1u_9", n = "_block_39g1u_14", r = "_semibold_39g1u_18", i = "_italic_39g1u_22", a = "_secondary_39g1u_26", o = "_error_39g1u_30", s = "_monoText_39g1u_34", c = "_monoText_bold_39g1u_43", l = {
	text: e,
	small: t,
	block: n,
	semibold: r,
	italic: i,
	secondary: a,
	error: o,
	monoText: s,
	monoText_bold: c
};
//#endregion
export { n as block, l as default, o as error, i as italic, s as monoText, c as monoText_bold, a as secondary, r as semibold, t as small, e as text };
